import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { RouteList } from './RouteList';
import { Switch } from 'react-router';
import { useTranslation } from 'react-i18next';

export const Routes: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<div>{t('billing:common.loading', 'Loading...')}</div>}>
      <Switch>
        {Object.entries(RouteList).map(([key, pageProps]) => (
          <Route key={key} exact={true} {...pageProps} />
        ))}
      </Switch>
    </Suspense>
  );
};
